import { Button, FormControl, InputLabel, Select, MenuItem, Grid, TextField } from "@material-ui/core"
import { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { ToastMessage } from "../../../global/ToastMessage"
import BackDrop from "../../../global/BackDrop"
import { consultaPenalizacionAddPasajeroAction, AddPasajeroAction, consultaPasajerosAction, consultaSolicitudesPasajeroAction, changeCambioPasajeroTapAction, consultaDetalleViajeAction } from "./../../../ducks/cambiosDuck"
import { DialogMessage } from "../../../global/DialogMessage"

const catTipoPasajero = {
    ADULTO: 1,
    MENOR: 2,
    INFANTE: 3,
}
const catalogoTipo = [
    {
        id: 1,
        descripcion: "Adultos"
    },
    {
        id: 2,
        descripcion: "Menores"
    },
    {
        id: 3,
        descripcion: "Infantes"
    },
]
const FNuevoPasajero = () => {
    const { cliente, viaje, referencia } = useSelector(store => store.cambios)
    const [value, setValue] = useState("0")
    const [cantidad, setCantidad] = useState(0)
    const [load, setLoad] = useState(false)
    const [editar, setEditar] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        const tipo = catalogoTipo.find(tipo => tipo.id === value)
        const consultarPenalizacion = (tipo) => {
            setLoad(true)
            dispatch(consultaPenalizacionAddPasajeroAction({
                IdPaquete: viaje.Paquete?.Id_Paquete,
                Adultos: (tipo.id === catTipoPasajero.ADULTO) ? cantidad : 0,
                Infantes: (tipo.id === catTipoPasajero.INFANTE) ? cantidad : 0,
                Menores: (tipo.id === catTipoPasajero.MENOR) ? cantidad : 0,
            })).then(Response => {
                setLoad(false)
                if (Response.status === 500) {
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema intentar mas tarde",
                    });
                    return null;
                }
                if (Response.status === 400) {
                    ToastMessage.fire({
                        icon: "warning",
                        title: Response.Message,
                    });
                    return null;
                }
                dispatch(consultaPasajerosAction({ IdPaquete: viaje.Paquete?.Id_Paquete }))
            })
        }
        if (tipo)
            consultarPenalizacion(tipo)
        return () => {

        }
    }, [dispatch, cantidad, value])

    const handleGuardar = () => {
        if (cantidad === 0)
            return null
        if (value === "0")
            return null
        DialogMessage.fire({
            title: `Cambio psajero`,
            text: `¿Esta seguro de agregar un nuevo pasajero para la referencia: #${referencia}?`,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                const tipo = catalogoTipo.find(tipo => tipo.id === value)
                const payload = {
                    IdPaquete: viaje.Paquete?.Id_Paquete,
                    [`${tipo.descripcion}`]: cantidad
                }
                dispatch(AddPasajeroAction(payload)).then(Response => {
                    setLoad(false)
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(consultaDetalleViajeAction())
                    dispatch(changeCambioPasajeroTapAction({ tapValue: 0 }))
                    dispatch(consultaSolicitudesPasajeroAction({ IdPaquete: cliente?.paquete?.Id_Paquete }))
                    hangdleClickCancelar()
                    handleClearState()
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                })
            }
        })
    }

    const handleSelecTipo = (event) => {
        setValue(event.target.value)
    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    const hangdleClickCancelar = () => {
        setEditar(!editar)
        handleClearState()
    }
    const handleClearState = () => {
        setValue("0")
        setCantidad(0)
    }
    const handleChange = (event) => {
        setCantidad(event.target.value)
    }
    if (catalogoTipo.length > 0) return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <FormControl variant="outlined" style={{ width: "100%" }}>
                            <InputLabel id="lTipo">Tipo pasajero</InputLabel>
                            <Select
                                disabled={!editar}
                                labelId="lTipo"
                                id="STipo"
                                name="STipo"
                                onChange={handleSelecTipo}
                                label="Tipo pasajero"
                                value={value}
                            >
                                <MenuItem value="0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {catalogoTipo.map((tipo, index) => (
                                    <MenuItem key={index} value={tipo.id}>
                                        {`${tipo.descripcion}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <TextField
                            disabled={!editar}
                            value={cantidad}
                            style={{ width: "40%" }}
                            id={`outlined-number-conter`}
                            label="Cantidad"
                            name="cantidad"
                            onChange={handleChange}
                            type="number"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                inputProps: { min: 0, max: 10 }
                            }}
                            variant="outlined"
                        />
                        {
                            (!editar) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                onClick={hangdleClickEditar}
                            >
                                Editar
                            </Button>
                        }
                        {
                            (editar) &&
                            <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="primary"
                                    disabled={value === "0" || cantidad === 0}
                                    onClick={handleGuardar}
                                >
                                    Guardar
                                </Button>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="default"
                                    onClick={hangdleClickCancelar}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
            <BackDrop open={load} />
        </div>
    )
    return <div>
        No hay fechas diponibles para el paquete <b>{cliente?.paquete?.Nombre}</b>
    </div>
}
export default FNuevoPasajero